module.exports = __webpack_public_path__ + "img/1.70eccfd5.png";